import client from './client'
import type {
  PublicVolunteerInfo,
  PublicVolunteerSignUp,
  VolunteerSignUpPayload,
  VolunteerEmailCheckResult,
} from '@/types/volunteer'

export async function getInfo(eventSlug: string): Promise<PublicVolunteerInfo> {
  const { data } = await client.get<{ data: PublicVolunteerInfo }>(
    `/public/events/${eventSlug}/volunteer`,
  )
  return data.data
}

export async function checkEmail(
  eventSlug: string,
  email: string,
): Promise<VolunteerEmailCheckResult> {
  const { data } = await client.get<VolunteerEmailCheckResult>(
    `/public/events/${eventSlug}/volunteer/check-email`,
    { params: { email } },
  )
  return data
}

export async function submitSignUp(
  eventSlug: string,
  payload: VolunteerSignUpPayload,
): Promise<PublicVolunteerSignUp> {
  const { data } = await client.post<{ data: PublicVolunteerSignUp }>(
    `/public/events/${eventSlug}/volunteer/sign-up`,
    payload,
  )
  return data.data
}

export async function getConfirmation(confirmationToken: string): Promise<PublicVolunteerSignUp> {
  const { data } = await client.get<{ data: PublicVolunteerSignUp }>(
    `/public/volunteer-confirmations/${confirmationToken}`,
  )
  return data.data
}
